import service, {
  IProduct,
  IProductId,
} from '@/services/product';
import { IPage } from '@/services/gql/generic-find';
import { debounceSearch, promiseError } from '@/store/utils';
import { IStateProducts } from './types';

export default () => ({
  namespaced: true,
  state: () => ({
    list: [],
    loadSeeds: [],
    page: {
      number: 1,
      query: {},
      recordCount: 0,
      size: 10,
    },
  } as IStateProducts),
  getters: {
    isSearchLoading: (state: IStateProducts) => !!state.loadSeeds.length,
  },
  mutations: {
    LOAD(state: IStateProducts, data: IProduct[] = []) {
      state.list = data;
    },
    LOAD_SEED_ADD(state: IStateProducts, seed: number) {
      state.loadSeeds = state.loadSeeds.concat(seed);
    },
    LOAD_SEED_CLEAR(state: IStateProducts) {
      state.loadSeeds = [];
    },
    LOAD_SEED_REMOVE(state: IStateProducts, seed: number) {
      state.loadSeeds = state.loadSeeds.filter(loadSeed => loadSeed !== seed);
    },
    REMOVE(state: IStateProducts, id: IProductId) {
      // reduce record count by 1
      state.page.recordCount = state.page.recordCount - 1;

      // remove item from list
      state.list = state.list.filter((item: IProduct) => (
        item.id !== id
      ));
    },
    UPDATE_PAGE(state: IStateProducts, payload: any) {
      state.page = {
        ...state.page,
        ...payload,
      };
    },
  },
  actions: {
    load: ({ commit, state }: any, page: IPage) => (
      debounceSearch({
        commit,
        page,
        service,
        state,
        onSearch: (pageParams: any) => (
          service.find(`id, name`, {
            ...pageParams,
            where: state.page.query,
          })
        ),
      })
    ),
    remove: ({ commit }: any, id: string) => (
      service
        .remove(id)
        .then(() => commit('REMOVE', id))
        .catch(promiseError('PRODUCTS_REMOVE', commit))
    ),
  },
});
